import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';

export default function Layout() {
  const location = useLocation();
  
  // تتبع المسار عشان نتأكد
  console.log('Current path:', location.pathname);

  // نخفي Navbar و Footer فقط في login و register
  const hideLayout = location.pathname === '/login' || location.pathname === '/register';

  return (
    <>
      {!hideLayout && <Navbar />}
      <Outlet />
      {!hideLayout && <Footer />}
    </>
  );
}
